import { AxiosPromise, AxiosRequestConfig } from 'axios';

import {
  CloudAppQuarantineDownloadActionReqDto,
  QuarantineDeleteActionReqDto,
  QuarantineDownloadActionReqDto,
  QuarantineLogContentReqDto,
  QuarantineLogContentResDto,
  QuarantineLogFacetReqDto,
  QuarantineLogFacetResDto,
  QuarantineRestoreActionReqDto,
  QuarantineRestoreAllReqDto,
} from '../pages/Quarantine/utils/types';
import { MailPreviewEnabledItem } from '../types/log';
import request from '../utils/request';

function apiGetQuarantineLogContent(
  params: QuarantineLogContentReqDto
): AxiosPromise<QuarantineLogContentResDto> {
  return request({
    url: `quarantine/contentList`,
    method: 'get',
    params,
  });
}

function apiGetQuarantineFacetContent(
  params: QuarantineLogFacetReqDto
): AxiosPromise<QuarantineLogFacetResDto> {
  return request({
    url: `quarantine/facetList`,
    method: 'get',
    params,
  });
}

function apiGetMailPreviewEnabledList(): AxiosPromise<
  MailPreviewEnabledItem[]
> {
  return request({
    url: `quarantine/mailPreviewEnabledList`,
    method: 'get',
  });
}

function apiUpdateMailPreviewEnabledList(
  items: MailPreviewEnabledItem[]
): AxiosPromise<{ status: string }> {
  return request({
    url: `quarantine/mailPreviewEnabledList`,
    method: 'post',
    data: {
      settingList: items,
    },
  });
}

function apiGetAutoDeleteDaysSetting(
  config?: AxiosRequestConfig
): AxiosPromise<{
  expiredDay: number;
}> {
  return request({
    url: `quarantine/autoDeleteDays`,
    method: 'get',
    ...config,
  });
}

function apiUpdateAutoDeleteDaysSetting(expiredDay: number) {
  return request({
    url: `quarantine/autoDeleteDays`,
    method: 'post',
    data: {
      expiredDay,
    },
  });
}

function apiGetMailPreviewContent(
  blobPath: string,
  traceId: string
): AxiosPromise<string> {
  return request({
    url: 'quarantine/mailPreviewContent/search',
    method: 'post',
    data: {
      blobPath,
      traceId,
    },
  });
}

function apiDeleteQuarantineLogs(
  url: string,
  data: QuarantineDeleteActionReqDto
) {
  return request({
    url: `quarantine/${url}`,
    method: 'post',
    data,
  });
}

function apiRestoreQuarantineLogs(
  url: string,
  data: QuarantineRestoreActionReqDto
) {
  return request({
    url: `quarantine/${url}`,
    method: 'post',
    data,
  });
}

function apiRestoreAllQuarantineLogs(data: QuarantineRestoreAllReqDto) {
  return request({
    url: 'quarantine/restoreAll',
    method: 'post',
    data,
  });
}

function apiDownloadQuarantineLogs(
  url: string,
  data: QuarantineDownloadActionReqDto
) {
  return request({
    url: `quarantine/${url}`,
    method: 'post',
    data,
    timeout: 5 * 60 * 1000,
    responseType: 'blob',
  });
}

function apiDownloadCloudAppQuarantineLogs(
  url: string,
  data: CloudAppQuarantineDownloadActionReqDto
): AxiosPromise<{
  data: string;
  error: string;
  result: string;
}> {
  return request({
    url: `quarantine/${url}`,
    method: 'post',
    data,
  });
}

//od quarantine setting api
function apiGetOneDriveDedicatedQuarantineSetting() {
  return request({
    //url: `quarantine/od_quarantine_setting`,
    url: `quarantine/temp`,
    method: 'get',
  });
}
function apiPostOneDriveDedicatedQuarantineSetting() {
  return request({
    // url: `quarantine/od_quarantine_setting`,
    url: `quarantine/temp`,
    method: 'post',
    data: {
      site: 'https://tmdevorg.sharepoint.com/sites/communication_1/',
      type: 0,
    },
  });
}
function apiVerifyOneDriveDedicatedSiteURL(site: string) {
  //https://tmdevorg.sharepoint.com/sites/communication_1/
  return request({
    // url: `quarantine/verify_od_dedicated_quarantine_site`,
    url: `quarantine/temp`,
    method: 'post',
    data: { site },
  });
}

//ex quarantine setting
function apiGetExchangeQuarantineSetting() {
  return request({
    // url: `quarantine/exchange_dedicated_mailbox`,
    url: `quarantine/temp`,
    method: 'get',
  });
}
function apiPostExchangeQuarantineSetting() {
  return request({
    // url: `quarantine/exchange_dedicated_mailbox`,
    url: `quarantine/temp`,
    method: 'post',
    data: {
      mailboxes: '',
      gmailQtSetting: '', //enable | disable
    },
  });
}
function apiVerifyExchangeMailbox(mailboxes: string[]) {
  //https://tmdevorg.sharepoint.com/sites/communication_1/
  return request({
    // url: `quarantine/exchange_validate_dedicated_mailbox`,
    url: `quarantine/temp`,
    method: 'post',
    data: { mailboxes },
  });
}

//gmail quarantine setting
function apiGetGmailDedicatedQuarantineSetting(): AxiosPromise<{
  mailBoxList: string[];
}> {
  return request({
    url: `quarantine/gmail/dedicatedMailbox`,
    method: 'get',
  });
}
function apiPostGmailDedicatedQuarantineSetting(
  mailBoxList: string[]
): AxiosPromise<{
  status: string;
}> {
  return request({
    url: `quarantine/gmail/dedicatedMailbox`,
    method: 'post',
    data: {
      mailBoxList,
    },
  });
}
function apiVerifyGmailDedicatedMailbox(mailBoxList: string[]): AxiosPromise<
  | { status: 'success' }
  | {
      invalidMailbox: string;
      status: 'failed';
      statusCode: number;
      maxMailBoxNum?: number;
    }
> {
  return request({
    url: `quarantine/gmail/dedicatedMailbox/validate`,
    method: 'post',
    data: { mailBoxList },
  });
}

export default {
  apiGetQuarantineLogContent,
  apiGetQuarantineFacetContent,
  apiGetMailPreviewEnabledList,
  apiUpdateMailPreviewEnabledList,
  apiGetAutoDeleteDaysSetting,
  apiUpdateAutoDeleteDaysSetting,
  apiGetMailPreviewContent,
  apiDeleteQuarantineLogs,
  apiRestoreQuarantineLogs,
  apiRestoreAllQuarantineLogs,
  apiDownloadQuarantineLogs,
  apiDownloadCloudAppQuarantineLogs,
  apiGetOneDriveDedicatedQuarantineSetting,
  apiPostOneDriveDedicatedQuarantineSetting,
  apiVerifyOneDriveDedicatedSiteURL,
  apiGetExchangeQuarantineSetting,
  apiPostExchangeQuarantineSetting,
  apiVerifyExchangeMailbox,
  apiGetGmailDedicatedQuarantineSetting,
  apiPostGmailDedicatedQuarantineSetting,
  apiVerifyGmailDedicatedMailbox,
};
